import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const CamsRedirect = ({ setLocale }) => {
  const { langAndToken } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const langPrefix = langAndToken.substring(0, 4);
    const token = langAndToken.substring(4);

    if (langPrefix !== 'enCA' && langPrefix !== 'frCA') {
      navigate('/404');
      return;
    }

    const newLocale = langPrefix.startsWith('en') ? 'en' : 'fr';
    if (setLocale) {
      sessionStorage.setItem('locale', newLocale);
      setLocale(newLocale);
    }

    navigate(`/activate/${token}`, { replace: true });
  }, [langAndToken, navigate, setLocale]);

  return null;
};

export default CamsRedirect;
